import { api } from '../../lib/api.ts';

export interface FamilyNode {
  /** Person id, or a "v:…" id for a parent who isn't in the register. */
  id: string;
  name: string;
  resident: boolean;
  sex: 'M' | 'F' | null;
  birthYear: number | null;
  status: 'ACTIVE' | 'MOVED_OUT' | 'DECEASED' | null;
  house: { id: string; name: string; number: number | null } | null;
  fatherId: string | null;
  motherId: string | null;
}

export interface FamilyView {
  focus: FamilyNode;
  father: FamilyNode | null;
  mother: FamilyNode | null;
  grandparents: { paternal: [FamilyNode | null, FamilyNode | null]; maternal: [FamilyNode | null, FamilyNode | null] };
  siblings: Array<{ node: FamilyNode; half: boolean }>;
  families: Array<{ partner: FamilyNode | null; children: Array<{ node: FamilyNode; children: FamilyNode[] }> }>;
}

export interface RelationStep { node: FamilyNode; via: 'start' | 'parent' | 'child' | 'partner' }
export interface RelationWay {
  label: string;
  kind: 'blood' | 'marriage' | 'distant';
  commonAncestors: FamilyNode[];
  path: RelationStep[];
}
export interface Relation {
  label: string | null;
  kind: 'self' | 'blood' | 'marriage' | 'distant' | 'none';
  commonAncestors: FamilyNode[];
  path: RelationStep[];
  /** Every distinct way the two are connected, shortest first. */
  ways: RelationWay[];
}

export interface FamilyGroup { head: FamilyNode; residents: number; houses: number }

export const familyApi = {
  view: (id: string) => api.get<{ view: FamilyView }>('/family/node', { params: { id } }).then((r) => r.data.view),
  relation: (a: string, b: string) =>
    api.get<{ relation: Relation }>('/family/relation', { params: { a, b } }).then((r) => r.data.relation),
  groups: () =>
    api.get<{ groups: FamilyGroup[]; unlinked: number; residents: number }>('/family/groups').then((r) => r.data),
  search: (q: string) => api.get<{ people: FamilyNode[] }>('/family/search', { params: { q } }).then((r) => r.data.people),
};
